module.exports = __webpack_public_path__ + "img/Carrousels STARTO_rdv_slide_2.e4a29343.png";